module.exports = __webpack_public_path__ + "static/media/avatar.2afda55a.svg";